import React from 'react'
import { FormControl } from 'react-bootstrap'

const ImageInput = (props) => (
  <form onSubmit={props.handleImageSubmit}>
    <FormControl
      style={{ borderRadius: 4 }}
      type='text'
      value={props.value}
      placeholder='Search by photo'
      onChange={props.handleFieldChange}
    />
  </form>
)

export default ImageInput
